import React from 'react';
import { compose } from 'recompose'
import { connect } from 'react-redux'
import AuthUserContext from './AuthUserContext';
import { firebase } from '../firebase';
import { withRouter } from 'react-router-dom';
import { Spinner } from 'scorpion-core';

import { actionsAfterLogin } from '../App/functions';
const withAuthentication = (Component) => {


    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                authUser: null,
            };
        }

        componentDidMount() {
            const { history, } = this.props;
            firebase.auth.onAuthStateChanged(authUser => {
                if (authUser) {
                    this.setState({ authUser })
                    if (this.props.actionsAfterLogin)
                        this.props.actionsAfterLogin(authUser)

                } else {
                    this.setState({ authUser: { loading: true } })
                    history.push("/Login");                   
                }
            });
        }
        componentWillReceiveProps(props) {


        }

        render() {
            const { authUser } = this.state;

            return (
                <AuthUserContext.Provider value={authUser}>
                    {authUser && (authUser.loading || authUser.uid) ?

                        <Component {...this.props} />
                        : <Spinner />}
                </AuthUserContext.Provider>
            );
        }
    }
    // return withRouter(WithAuthentication)
    const mapStateToProps = (state, props) => {
        return {};
    };

    return compose(
        withRouter,
        connect(mapStateToProps, { actionsAfterLogin }),
    )(WithAuthentication);
}

export default withAuthentication;


// WEBPACK FOOTER //
// ./src/components/withAuthentication.js